import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useWalletProvider } from "../walletprovider/useWalletProvider";
import InvitationsExperience from "../magic-link/InvitationsExperience";
import { getUserProfileJwt } from "../utils/dwclient/dwclientutils";
import { loadJwt } from "../utils/dwclient/localstorage/jwtStorage";
import { FILES_PAGE } from "../data/pages";
import { getInvitationsBackNavigation } from "./invitationsNavigation";

// Dedicated page for guest invitations and the meeting calendar.
// Extracted from SettingsPage as the invite tooling grew; uses the same
// layout classes so the look & feel matches Settings.
const InvitationsPage = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const { selectedWallet, selectedAccount } = useWalletProvider();
  const returnToSecureChat = location.state?.returnToSecureChat === true;
  const backNavigation = getInvitationsBackNavigation(
    returnToSecureChat,
    FILES_PAGE.url,
  );

  // The organizer's own profile e-mail (Settings → Profile). When present,
  // creating a conference or scheduling a meeting also sends them a
  // calendar-sync mail. Best effort — no e-mail in the profile is fine.
  const [hostEmail, setHostEmail] = useState(null);
  useEffect(() => {
    if (!selectedWallet?.provider || !selectedAccount) {
      setHostEmail(null);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const authToken = await loadJwt();
        const profile = await getUserProfileJwt(selectedWallet.provider, authToken);
        if (!cancelled) setHostEmail(profile?.email || null);
      } catch (err) {
        console.warn("[Invitations] Profile email unavailable:", err?.message || err);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [selectedWallet?.provider, selectedAccount]);

  const handleBack = () => {
    navigate(backNavigation.destination, backNavigation.options);
  };

  return <InvitationsExperience
    key={location.key}
    initialKind={location.state?.invitationTab === "scheduled" ? "scheduled" : "instant"}
    hostWallet={selectedAccount}
    walletProvider={selectedWallet?.provider}
    hostEmail={hostEmail}
    onBack={handleBack}
    backLabel={t(backNavigation.labelKey)}
  />;
};

export default InvitationsPage;
